module.exports = __webpack_public_path__ + "static/media/1.64f0ef8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/600591/1.jpg
// module id = 685
// module chunks = 0